import { developments } from "@/mocks/site";

export default function TimelineSection() {
  return (
    <ol className="relative flex flex-col gap-6 border-l border-background-300 pl-6 md:pl-8">
      {developments.map((item) => (
        <li key={item.year} className="relative">
          <span className="absolute -left-[31px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-primary-500 ring-4 ring-background-50 md:-left-[39px]"></span>
          <span className="inline-flex items-center rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-900">
            {item.year}
          </span>
          <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
        </li>
      ))}
    </ol>
  );
}